import type { ReactNode } from 'react'
import React from 'react'
import type { ModalContentProps, StyleProp } from '@vtex/admin-ui'
import { ModalContent, csx } from '@vtex/admin-ui'

const containerStyles: StyleProp = {
  padding: '$space-0',
}

export type SalesAssociateMovementsTrackingModalContentProps = Pick<
  ModalContentProps,
  'className'
> & {
  children: ReactNode
}

export const SalesAssociateMovementsTrackingModalContent = ({
  className,
  children,
}: SalesAssociateMovementsTrackingModalContentProps) => (
  <ModalContent className={`${csx({ ...containerStyles })} ${className}`}>
    {children}
  </ModalContent>
)
